module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/PatriotGames.06a352c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/PatriotGames.jpg
// module id = jxmE
// module chunks = 0